define('bizzabo/views/right/AgendaPreviewView',[
    'backbone',
    'bizzabo/config',
    'bizzabo/views/popup/ImportAgendaView',
    'bizzabo/views/right/AgendaErrorsView',
    'bizzabo/views/popup/DeleteSessionOnBulkUploadView',
    'hbars!bizzabo/templates/agendaPreview'
], function(
    Backbone,
    CONFIG,
    ImportAgendaView,
    AgendaErrorsView,
    DeleteSessionOnBulkUploadView,
    template
    ) {

    var AgendaPreviewView = Backbone.View.extend({

        events: {
            'click .push-message-box-tab': 'tabClicked',
            'click .bulk-upload-button': 'importAgendaClicked'
        },

        initialize: function(options) {
            this.agenda = options.agenda;
            this.listenTo(this.model, 'change:id', this.render);

            if (CONFIG.ALLOW_IMPORT_AGENDA) {
                this.agendaErrorsView = new AgendaErrorsView({
                    model: this.agenda,
                    el: this.$('.agenda-errors-view')
                });
                this.listenTo(this.agenda, 'agendaValidated', _.debounce(this.activeAgendaValidated, 300));
            }
            this.hasSessionRegistration = false;
            this.agenda.get('day').each(function(day){
                _.each(day.get('session').models, function(session) {
                    if (session.get('registration')){
                        this.hasSessionRegistration = true;
                    }
                }, this)
            }, this)
        },

        remove: function() {
            this.agendaErrorsView && this.agendaErrorsView.remove();
            return Backbone.View.prototype.remove.call(this);
        },

        activeAgendaValidated: function(isValid, model, numberOfErrors) {
            var element = this.$('.error-counter-bubble');
            if (numberOfErrors <= 0) {
                element.empty().addClass('hide');
            } else {
                element.text(numberOfErrors).removeClass('hide');
            }
        },

        tabClicked: function(e) {
            var tabName = $(e.target).attr('name') || $(e.target.parentElement).attr('name');
            this.switchToTab(tabName);
        },

        switchToTab: function(tabName) {
            var types = {
                'intro': false,
                'bulk-upload': false,
                'agenda-errors': false
            };

            types[tabName] = true;
            _.each(types, function(value, key) {
                this.$('.push-message-box-tab.' + key).toggleClass('selected', value);
                this.$('.push-messages-image.' + key).toggleClass('hide', !value);
            }, this);
        },

        importAgendaClicked: function() {
            var thisView = this;
            if (this.hasSessionRegistration) {
                var deleteSessionOnBulkUploadPopup = new DeleteSessionOnBulkUploadView(
                    {
                        model: this.model,
                        title: "Delete Session Registration",
                        html: '<p>You currently have sessions with registrations enabled. Be aware that when uploading a new agenda all current sessions and all of their registrations will be deleted. This action cannot be undone.</p>',
                        onAllow: function() {
                            thisView.showImportAgenda();
                        }
                    });
                deleteSessionOnBulkUploadPopup.show();
            }
            else {
                this.showImportAgenda();
            }
        },

        showImportAgenda: function() {
            new ImportAgendaView({
                model: this.agenda
            }).show();
        },

        render: function() {
            var source = _.extend(this.model, {
                enableImportExport: CONFIG.ALLOW_IMPORT_AGENDA,
                numberOfAgendaErrors: this.agenda.numberOfErrors(),
                hasAgendaErrors: (this.agenda.numberOfErrors() > 0)
            });
            var html = template(source);
            this.$el.html(html);
            this.agendaErrorsView && this.agendaErrorsView.setElement(this.$('.agenda-errors-view')).render();
            return this;
        }
    });

    return AgendaPreviewView;
});
